import { useSettingsStore } from '../store'
import { HourConfigField } from './HourConfigField'

export function WorkflowsHoursTab() {
  const { hourSettings, updateWorkflowsHours } = useSettingsStore()
  const wf = hourSettings.workflows

  return (
    <div className="space-y-6">
      {/* Workflow Setup */}
      <div className="bg-[var(--bg-secondary)] border border-[var(--border-color)] rounded-lg p-4">
        <h4 className="text-sm font-medium text-[var(--text-primary)] mb-3">Workflow Setup</h4>
        <HourConfigField
          label="Per Builder Workflow"
          value={wf.perBuilderWorkflow}
          onChange={(v) => updateWorkflowsHours('perBuilderWorkflow', v)}
          description="Hours per workflow created with the builder"
        />
        <HourConfigField
          label="Per Complex Workflow"
          value={wf.perComplexWorkflow}
          onChange={(v) => updateWorkflowsHours('perComplexWorkflow', v)}
          description="Hours per complex/external workflow link"
        />
      </div>

      {/* Step Configuration */}
      <div className="bg-[var(--bg-secondary)] border border-[var(--border-color)] rounded-lg p-4">
        <h4 className="text-sm font-medium text-[var(--text-primary)] mb-3">Step Configuration</h4>
        <HourConfigField
          label="Per Workflow Step"
          value={wf.perWorkflowStep}
          onChange={(v) => updateWorkflowsHours('perWorkflowStep', v)}
          description="Hours per step (blocklist, KYC, AML, IDV, fraud, risk, etc.)"
        />
        <HourConfigField
          label="Per Risk Branch"
          value={wf.perRiskBranch}
          onChange={(v) => updateWorkflowsHours('perRiskBranch', v)}
          description="Hours per risk branch within a risk step"
        />
        <HourConfigField
          label="Per Cascade Source"
          value={wf.perCascadeSource}
          onChange={(v) => updateWorkflowsHours('perCascadeSource', v)}
          description="Hours per cascade data source in a KYC step"
        />
      </div>
    </div>
  )
}
